<template>

    <div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="params.fab ? params.fab : false"
						:icon="params.fab ? false : true"
						:small="params.small ? true : false"
						:fixed="params.fixed ? true : false"
						:bottom="params.bottom ? true : false"
						:right="params.right ? true : false"
						:dark="params.dark ? true : false"
						:color="params.button_color ? params.button_color : ''"
						@click="toggleDialog">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ icon }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ tooltipText }}</span>
    		</v-tooltip>
		</template>

        <v-list-item v-else-if="buttonComponent == 'v-list-item'"
			dense 
			:disabled="disabled"
			@click.stop="toggleDialog(true)"
			ripple>
			<v-list-item-icon>
				<v-icon style="font-size: 18px">{{ icon }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ tooltipText }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

        <generate-trouble-dialog
            :open.sync="show"
            :model-def="modelDef"
            :params="button.params"
            @close="toggleDialog(false)"
            :selectedIds="[model.id]"
            :selected="[{'id': model.id}]"
        ></generate-trouble-dialog>
    </div>
</template>

<script>
    import GenerateTroubleDialog from '@/components/modules/tickets/GenerateTroubleDialog'

    export default {
        name: 'generate-trouble-button-component',
        components: {
            GenerateTroubleDialog
        },

        props: {
            button: Object,
		    buttonComponent: {type: String, default : 'v-btn'},
            model: Object,
            modelDef: String,
            params: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            disabled: Boolean
        },

        data() {
            return {
                show: false
            }
        },

        computed: {

            icon() {
                if (this.button.params && this.button.params.icon) {
                    return this.button.params.icon
                } else {
                    return 'mdi-receipt-text'
                }
            },
            
            tooltipText() {
                if (this.button.params && this.button.params.tooltip) {
                    return this.button.params.tooltip
                } else {
                    return 'Genera Ticket'
                }
            },
        },

        methods: {
            toggleDialog(value) {
                this.show = value
            }
        }
    }
</script>